/* Plug Footer — mobile accordion toggle.

   The desktop layout shows all menu lists at once; mobile (<750px)
   collapses each column behind its title. The CSS hides
   .pgs-footer-menu-list when the sibling button has
   aria-expanded="false". This script just flips that attribute when
   the title is clicked.

   Click is delegated off `document` so blocks added via the theme
   editor (which re-renders sections) work without re-binding. */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pgs-footer-toggle]');
    if (!btn) return;
    var expanded = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
  });
})();
